import { GET, POST } from "../../Methods";
import { APIS } from "../../APIS";

export const Settings = async () => {
  try {
    return await GET(APIS.Common.AppSetup);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllState = async () => {
  try {
    return await GET(APIS.Common.AllState);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllBanner = async () => {
  try {
    return await GET(APIS.Common.AllBanner);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllBigWin = async () => {
  try {
    return await GET(APIS.Common.AllBigwin);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllAgent = async () => {
  try {
    return await GET(APIS.Common.AllAgent);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllLeaderboard = async () => {
  try {
    return await GET(APIS.Common.AllLeaderboard);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllGames = async () => {
  try {
    return await GET(APIS.Common.AllGames);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllCompetitionsMatchs = async (
  competition_id = 0,
  game_id = 0,
) => {
  try {
    let url = APIS.Common.AllCompetitionsMatchs;

    if (competition_id) {
      url += `competition_id=${competition_id}&`;
    }
    if (game_id) {
      url += `game_id=${game_id}&`;
    }
    return await GET(url);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const MatchDetails = async (id = 0) => {
  try {
    let url = APIS.Common.MatchDetails;

    if (id) {
      url += `/${id}`;
    }

    return await GET(url);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const MatchOdds = async (id = 0) => {
  try {
    let url = APIS.Common.MatchOdds;

    if (id) {
      url += `/${id}`;
    }

    return await GET(url);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AllLiveMarketsData = async () => {
  try {
    return await GET(APIS.Common.AllLiveMarketsData);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const OnlyLiveGamesMatches = async (competition_id = 0, game_id = 0) => {
  try {
    let url = APIS.Common.OnlyLiveGamesMatches;

    if (competition_id) {
      url += `competition_id=${competition_id}&`;
    }
    if (game_id) {
      url += `game_id=${game_id}&`;
    }
    return await GET(url);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const MarketAnalysisLiveGamesMatches = async (
  competition_id = 0,
  game_id = 0,
) => {
  try {
    let url = APIS.Common.MarketAnalysisLiveGamesMatches;

    if (competition_id) {
      url += `competition_id=${competition_id}&`;
    }
    if (game_id) {
      url += `game_id=${game_id}&`;
    }
    return await GET(url);
  } catch (error) {
    console.error(error);
    return error;
  }
};

// Policy
export const GETRules = async () => {
  try {
    return await GET(APIS.Common.Rules);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GETTAndC = async () => {
  try {
    return await GET(APIS.Common.TAndC);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GETPrivacy = async () => {
  try {
    return await GET(APIS.Common.Privacy);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GETSocialMedia = async () => {
  try {
    return await GET(APIS.Common.SocialMedia);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const POSTContactUs = async (data) => {
  try {
    return await POST(APIS.Common.ContactUs, data);
  } catch (error) {
    console.error(error);
    return error;
  }
};
